/**
 * File: WeblinkController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class WeblinkController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let resourceId = $state.params.resourceId;
        let plan = localStorageService.get("currentPlan")
        var save_url = TPWIZARDCONSTANT.API_SAVE_KHANACADEMY

        /*
         * To Call khanacademy API
         * @title : String - khanacademy title
         * @callback : Function - To return response from server
         * @return : null
         * @Developer: Arul Mozhi J
         */
        var callKhanAcademyAPI = function(title, callback) {
            try {
                var url = TPWIZARDCONSTANT.KHANACADEMY_URL + title
                console.log(url)
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        let resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        try {
                            resultObj.result = JSON.parse(xhttp.responseText);
                            callback(resultObj);
                        } catch (error) {
                            resultObj.error = "Bad Request - End Point is invalid";
                            callback(resultObj);
                        }
                    } else {
                        if (this.readyState == 4) {
                            let resultObj = {
                                "result": undefined,
                                "error": undefined
                            };
                            resultObj.error = JSON.parse(xhttp.responseText);
                            callback(resultObj);
                        }
                    }
                };
                xhttp.open('GET', url, true);
                xhttp.onerror = function(e) {
                    let resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    resultObj.error = "Bad Request - Server is Down";
                    callback(resultObj);
                };
                xhttp.send();
            } catch (ex) {
                console.log(ex);
            }
        }

        var validate = () => {
            let errorCount = 0
            if ($scope.resource.academyTitle) {
                if ($scope.resource.academyTitle.trim() === "") {
                    $scope.errors.academyTitle = "";
                    errorCount++;
                }
            }
            if ($scope.resource.academyTitle === undefined || $scope.resource.academyTitle === null || $scope.resource.academyTitle === "") {
                $scope.errors['academyTitle'] = "Plaese enter title";
                errorCount++;
            }
            return errorCount;
        }

        $scope.addResource = () => {
            $scope.errors = {}
            var errorCount = validate();
            if (errorCount === 0) {
                callKhanAcademyAPI($scope.resource.academyTitle, function(resultObj) {
                    if (resultObj.result) {
                        console.log(resultObj)
                        let result = resultObj.result;
                        if (result != undefined && result.url != undefined) {
                            let params = {
                                tp_id: planId,
                                _id: resourceId,
                                title: $scope.resource.title,
                                url: result.url,
                                readable_id: result.readable_id,
                                youtube_id: result.youtube_id,
                                thumb_url: result.thumbnail,
                                topic: result.title,
                                status: $scope.resource.status,
                                user_id: userId
                            }
                            authService.callAPI(save_url, "POST", params, (response) => {
                                if (response && response.result && response.result.data) {
                                    var result = response.result.data;
                                    toastr.success("Khan academy added successfully")
                                    localStorageService.set("currentPlan", result)
                                    $rootScope.setStatus(resourceId, result.status)
                                    _.defer(function() {
                                        $scope.$apply();
                                    });
                                } else {
                                    toastr.error("Network Error, please try later.")
                                }
                            })
                        }
                    } else {
                        toastr.error("No data against topic")
                        $scope.isSaveDisable = false;
                    }
                })
            }
        }

        $scope.resetResource = () => {
            $scope.resource.academyTitle = "";
            $scope.errors = {};
        }

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })
                if ($scope.resource.readable_id) {
                    $scope.resource.academyTitle = $scope.resource.readable_id;
                }
                _.defer(() => {
                    $scope.$apply();
                });
            }
        }

         /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "khanAcademy"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }

    };
}

export default WeblinkController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/khanAcademy.js